export const slugify = (text) => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 _]/g, '')  // Allow letters, numbers, spaces, and underscores
    .replace(/\s+/g, '_')         // Replace spaces with underscores
    .replace(/_+/g, '_');         // Collapse multiple underscores into one
};

export const generateId = () => {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));


